import { Box } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { WORK_PAGE_NS } from '../../i18n';
import { Tooltip } from '@diana/core';

export const LockIcon = () => {
  const { t } = useTranslation(WORK_PAGE_NS);

  return (
    <Tooltip
      targetNode={
        <LockOutlined
          sx={{
            width: '24px',
            height: '22px',
          }}
        />
      }
    >
      <Box sx={{ p: 1 }}>{t(`step.noPermission`)}</Box>
    </Tooltip>
  );
};
